import { useState } from "react";
import path from "ramda/src/path";
import map from "ramda/src/map";

import Api from "../../services/Api";
import useAuth from "../../routes/login/AuthContext";

import { IProps } from "./MaxNumberInput";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";
import { capitalize } from "../../helpers/capitalize";

export const useInputHandler = (props: IProps) => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const [value, setValue] = useState(props.value);
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { updateUnitTypeValues } = useNetworkContext();

  const handleError = (msg = "") => {
    showErrorSnackbar(capitalize(msg) || "An error occured. Please try again");
  };

  const handleResponse = (maxNumberOfMatches: number) => async ({
    success,
    body,
  }: Record<string, any>): Promise<any> => {
    if (!success) {
      handleError(path(["error", "description"], body));
    } else {
      showSuccessSnackbar("Saved Changes");
      updateUnitTypeValues(selectedNetworkId, props.l2Id, props.l3Id, {
        maxNumberOfMatches,
      });
      props.updateData(map(
        item => {
          if (item.l2Id === props.l2Id && item.l3Id === props.l3Id) {
            return ({
              ...item,
              maxNumberOfMatches
            });
          } else {
            return item;
          }
        }
      ));
    }
  };

  const handleOnBlur = async (newValue: string) => {
    if (Number(newValue) === value || isSuperAdminRead()) return;

    if (Number(newValue) < 0) {
      setValue(0);
      return;
    }

    setValue(Number(newValue));

    const body = {
      subnetworkCommands: [],
      unitTypeCommands: [
        {
          l1Id: selectedNetworkId,
          l2Id: props.l2Id,
          l3Id: props.l3Id,
          maxCapLimit: Number(newValue),
        },
      ],
    };

    Api.setMathingRules(selectedNetworkId, body, await getAuthToken())
      .then(handleResponse(Number(newValue)))
      .catch(handleError);
  };

  return {
    value,
    handleOnBlur,
  };
};
